module.exports = require('./getInstancePrefix')
